import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../baseQuery';

const exerciseApi = createApi({
  reducerPath: 'exercises',
  tagTypes: ['Exercise'],
  baseQuery,
  endpoints(builder) {
    return {
      fetchExercises: builder.query({
        providesTags: (result) =>
          result
            ? [
                { type: 'Exercise', id: 'LIST' },
                ...result.map((r) => ({ type: 'Exercise', id: r.id })),
              ]
            : [{ type: 'Exercise', id: 'LIST' }],
        query: (coach) => ({
          url: `?resource=exercise&coach=eq.${coach}&order=id.asc`,
          method: 'GET',
        }),
      }),

      createExercise: builder.mutation({
        invalidatesTags: [{ type: 'Exercise', id: 'LIST' }],
        query: (data) => ({
          url: `?resource=exercise`,
          method: 'POST',
          body: data,
        }),
      }),

      updateExercise: builder.mutation({
        invalidatesTags: (result, error, { id: exerciseId }) => [
          { type: 'Exercise', id: exerciseId },
          { type: 'Exercise', id: 'LIST' },
        ],
        query: ({ id: exerciseId, submitData }) => ({
          url: `?resource=exercise&id=eq.${exerciseId}`,
          method: 'PATCH',
          body: submitData,
        }),
      }),

      deleteExercise: builder.mutation({
        invalidatesTags: (result, error, exerciseId) => [
          { type: 'Exercise', id: exerciseId },
          { type: 'Exercise', id: 'LIST' },
        ],
        query: (exerciseId) => ({
          url: `?resource=exercise&id=eq.${exerciseId}`,
          method: 'DELETE',
        }),
      }),

      fetchExercise: builder.query({
        providesTags: (result, error, arg) => [{ type: 'Exercise', id: arg }],
        query: (exerciseId) => ({
          url: `?resource=exercise&id=eq.${exerciseId}`,
          method: 'GET',
        }),
      }),

      fetchExercisesByName: builder.query({
        providesTags: (result) =>
          result
            ? [
                { type: 'Exercise', id: 'LIST' },
                ...result.map((r) => ({ type: 'Exercise', id: r.id })),
              ]
            : [{ type: 'Exercise', id: 'LIST' }],
        query: (term) => ({
          url: `?resource=exercise&name=fts.${term}`,
          method: 'GET',
        }),
      }),
    };
  },
});

export const {
  useFetchExercisesQuery,
  useCreateExerciseMutation,
  useUpdateExerciseMutation,
  useDeleteExerciseMutation,
  useFetchExerciseQuery,
  useFetchExercisesByNameQuery,
} = exerciseApi;

export { exerciseApi };
